<template>
    <div class="price-content">
        <div class="price-content-dj">
            <div class="price-content-item">
                <div class="price-content-tit">免费版<span class="pricing" v-if="userInfo.companyInfo.companyResource.resourceVersion == 1">(正在使用)</span></div>
                <div class="price-content-tit-desc">0元永久使用</div>
                <div class="price-content-price">
                    <ul>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">人员数量</span>
                            <span class="num">3</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">应用数</span>
                            <span class="num">5</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">表单数量</span>
                            <span class="num">5</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">单表数据条数</span>
                            <span class="num">2000</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">报表数量</span>
                            <span class="num">2</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">BI数量</span>
                            <span class="num">2</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">业务流定义数</span>
                            <span class="num">---</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">审批流定义数</span>
                            <span class="num">5</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">可用空间</span>
                            <span class="num">50M</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">档案模板数量</span>
                            <span class="num">---</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">短信赠送条数</span>
                            <span class="num">---</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">运营数据分析</span>
                            <span class="num">---</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="price-content-item">
                <div class="price-content-tit yhprice">
                    <img src="~assets/img/price/u927.svg" class="yh" />
                    <p class="yhprice-tit">体验版<span class="pricing" v-if="userInfo.companyInfo.companyResource.resourceVersion == 2">&nbsp;(正在使用)</span></p>
                </div>
                <div class="price-content-tit-desc">
                    <span class="price-content-tit-desc-lit">￥</span>&nbsp;&nbsp;<span>998</span>&nbsp;
                    <span class="price-content-tit-desc-lit">/年</span>
                    <img src="~assets/img/price/u921.png" class="price-content-tit-desc-img" />
                    <span class="price-content-tit-desc-oldprice">1998/年</span>
                </div>
                <div class="price-content-price">
                    <ul>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">人员数量</span>
                            <span class="num">6</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">应用数</span>
                            <span class="num">20</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">表单数量</span>
                            <span class="num">50</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">单表数据条数</span>
                            <span class="num">5000</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">报表数量</span>
                            <span class="num">10</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">BI数量</span>
                            <span class="num">10</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">业务流定义数</span>
                            <span class="num">5</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">审批流定义数</span>
                            <span class="num">10</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">可用空间</span>
                            <span class="num">1G</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">档案模板数量</span>
                            <span class="num">---</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">短信赠送条数</span>
                            <span class="num">100</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">运营数据分析</span>
                            <span class="num">√</span>
                        </li>
                    </ul>
                    <el-button type="primary" class="price-content-opera jump-try" @click="handleUpgradeApply(2)" :loading="upgradeLoading">我要升级体验版</el-button>
                </div>
            </div>
            <div class="price-content-item">
                <div class="price-content-tit yhprice">
                    <img src="~assets/img/price/u927.svg" class="yh" />
                    <p class="yhprice-tit">企业版<span class="pricing" v-if="userInfo.companyInfo.companyResource.resourceVersion == 4">正在使用</span></p>
                </div>
                <div class="price-content-tit-desc">
                    <span class="price-content-tit-desc-lit">￥</span>&nbsp;<span>4980</span>
                    <span class="price-content-tit-desc-lit">/年</span>
                    <img src="~assets/img/price/u921.png" class="price-content-tit-desc-img" />
                    <span class="price-content-tit-desc-oldprice">9888/年</span>
                </div>
                <div class="price-content-price">
                    <ul>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">人员数量</span>
                            <span class="num">20</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">应用数</span>
                            <span class="num">不限</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">表单数量</span>
                            <span class="num">200</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">单表数据条数</span>
                            <span class="num">1万</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">报表数量</span>
                            <span class="num">20</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">BI数量</span>
                            <span class="num">20</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">业务流定义数</span>
                            <span class="num">10</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">审批流定义数</span>
                            <span class="num">20</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">可用空间</span>
                            <span class="num">10</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">档案模板数量</span>
                            <span class="num">5</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">短信赠送条数</span>
                            <span class="num">500</span>
                        </li>
                        <li class="price-content-price-item">
                            <span class="dato"></span>
                            <span class="ms">运营数据分析</span>
                            <span class="num">√</span>
                        </li>
                    </ul>
                    <el-button type="primary" class="price-content-opera jump-try" @click="handleUpgradeApply(4)" :loading="upgradeLoading">我要升级企业版</el-button>
                </div>
            </div>
            <!--<div class="price-content-item">
                <div class="price-content-tit">定制版</div>
                <div class="price-content-tit-desc">咨询高级业务专家</div>
                <div class="price-content-price">
                    <div class="price-content-opera price-content-opera-dz jump-try">
                        了解详情
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    import { upgradeSysApply } from '@/data-model';

    export default {
        components: {
        },
        data () {
            return {
                upgradeLoading: false
            };
        },
        props: {
            userInfo: {
                type: Object
            }
        },
        created () {
            // this.upgradeDes = '亲，您确认升级后，我们会收到您的请求信息。</br>您可以联系我们，联系电话 15373531270 13811849129 18833072251</br>如若24小时内您未曾来得及联系我们，24小时后我们将给您做一次回访';
        },
        methods: {
            async handleUpgradeApply (resourceVersion) {
                this.upgradeLoading = true;
                try {
                    await upgradeSysApply(resourceVersion);
                    setTimeout(() => { // 默认回显值
                        this.messageTip('申请成功，客服会及时回访您，请手机保持畅通！', 'success');
                    }, 800);
                } catch (error) {
                    // this.messageTip('发起申请失败，请联系客服处理', 'warning');
                    console.error('发起申请失败', error);
                } finally {
                    this.upgradeLoading = false;
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            }
        }
    };
</script>

<style lang="less" scope>
    @import '~assets/styles/price.less';
</style>



// WEBPACK FOOTER //
// src/components/UpgradePop/UpgradePop.vue